import React from "react";
import { ButtonVariantProps } from "../../components/atoms/ButtonVariant";
import { TooltipWrapper } from "../../components/atoms/TooltipWrapper";
import { BILLING_OWNER_REQUIRED_MESSAGE } from "../../components/organisms/taxReport/ActionOrPurchaseButton";
import { canUnlockPlanFeature } from "../../helper/canUnlockPlanFeature";
import { PlanAccount } from "./PlanAccount";
import { UnlockButton } from "./UnlockButton";

export function UnlockPlanButton({
  planName,
  account,
  onClick,
  isDisabled,
  ...props
}: {
  planName: string;
  account: PlanAccount;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
} & Omit<ButtonVariantProps, "content">) {
  const canUnlock = canUnlockPlanFeature(account);

  return (
    <TooltipWrapper
      tooltip={!canUnlock ? BILLING_OWNER_REQUIRED_MESSAGE : undefined}
    >
      <UnlockButton
        content={`Buy ${planName}`}
        onClick={onClick}
        data-event={`purchase-start-${planName}`}
        isDisabled={!canUnlock || isDisabled}
        {...props}
      />
    </TooltipWrapper>
  );
}
